<template>
    <div>
        <div class="filter-search" ref="sidemenu">
            <router-link to="/">
                <img :src="logoUrl" title="华夏安健-水质溯源系统" class="logo">
                </router-link>
                <el-input placeholder="请输入过滤内容" v-model="searchInput" suffix-icon="el-icon-search" size="mini" v-show="!isCollapse" style="width:90%;" @input="searchInputChange"></el-input>

</div>
        <el-menu default-active="1-4-1" :collapse="isCollapse"
                 background-color="#304156"
                 text-color="#bfcbd9"
                 active-text-color="#409EFF"
                 :default-openeds="openeds">
            <sidebar-item v-for="menu in menus" :key="menu.path" :menuItem="menu" />
        </el-menu>
    </div>
   
</template>

<script>
    import SidebarItem from './SidebarItem'

    export default {
        components: {
            SidebarItem
        },
        props: {
            isCollapse: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                logo: require("@/assets/img/logo.png"),
                logo_collapse: require("@/assets/img/logo_collapse.png"),
                searchInput: '',
                openeds:[]
            }
        },
        computed: {
            constantMenus: function () {
                return this.$store.getters.menu;
            },
            menus: function () {
                return this.constantMenus.filter(menu => {
                    if (!menu.enable) return false;
                    if (this.searchInput == "") return true;
                    var isFilter = !menu.title ? false : menu.title.indexOf(this.searchInput) > -1;
                    if (!isFilter && menu.children) {
                        var newChildren = menu.children.filter(cld => {
                            return !cld.title ? false : cld.title.indexOf(this.searchInput) > -1;
                        });
                        if (newChildren.length > 0) {
                            isFilter = true;
                            this.openeds.push(menu.path);
                        }
                    }
                    return isFilter;
                });
            },
            logoUrl: function () {
                return this.isCollapse ? this.logo_collapse : this.logo;
            }
        },
        methods: {
            searchInputChange() {
                this.openeds = [];
            }
        }
    }
</script>

<style scoped>
    
</style>